import { render } from "./ParticipantPassExamModal.vue?vue&type=template&id=024ea41d"
import script from "./ParticipantPassExamModal.vue?vue&type=script&lang=js"
export * from "./ParticipantPassExamModal.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Server-Testumgebung\\way-academy-app-main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__